import React, { useEffect, useRef } from'react';
import { gsap } from'../../animations/gsap.config';
import { ScrollTrigger } from'../../animations/gsap.config';

const ScrollProgress = () => {
 const barRef = useRef(null);

 useEffect(() => {
 const ctx = gsap.context(() => {
 gsap.to(barRef.current, {
 scaleX: 1,
 ease:'none',
 scrollTrigger: {
 trigger: document.documentElement,
 start:'top top',
 end:'bottom bottom',
 scrub: 0.3,
 },
 });
 });

 return () => ctx.revert();
 }, []);

 return (
 <div
 className="fixed top-0 left-0 right-0 z-[1000] h-[3px] pointer-events-none"
 style={{ background:'rgba(203,213,225,0.3)' }}
 >
 <div
 ref={barRef}
 className="h-full origin-left"
 style={{
 background:'linear-gradient(90deg, #1d4ed8, #3b82f6 50%, #f59e0b)',
 transform:'scaleX(0)',
 willChange:'transform',
 }}
 />
 </div>
 );
};

export default ScrollProgress;